import { getTable, getExportTable } from '../services';
export const fetchTable = ({ preset, limit, page, orderBy, query, campaignId, storeId, sellerId, cluster, }) => getTable({ preset, limit, page, orderBy, query, campaignId, storeId, sellerId, cluster }).then(response => formatResponse(response?.data));
const formatResponse = (response) => ({
    data: response?.data,
    errors: response?.errors,
    series: response?.series,
    success: response?.success,
    totalCount: response?.totalCount,
    dataCalcTotal: response?.dataCalcTotal,
    warnings: response?.warnings,
});
export const exportTable = ({ fileType, metrics, preset, campaignId, storeId, sellerId, cluster, }) => getExportTable({ fileType, metrics, preset, campaignId, storeId, sellerId, cluster }).then(response => formatExport(response?.data));
const formatExport = (response) => ({
    data: response?.data,
});
